var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuizColored(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 31,
    viewBox: "0 0 29 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 3C24 1.89543 23.1046 1 22 1H3C1.89543 1 1 1.89543 1 3V25C1 26.1046 1.89543 27 3 27H22C23.1046 27 24 26.1046 24 25V3Z",
    fill: "#F54F59",
    stroke: "#F54F59",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 7L7 7",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13L7 13",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 19H7",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 18L21.2 17L20 19L20.6 21L23.5 18Z",
    fill: "#F54F59"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1111 26.7143L16 25.8571V25.4286L14.2222 25L13.7778 25.4286L13.3333 25.8571L12.4444 26.5L11 28H12.4444H13.7778L15.1111 26.7143Z",
    fill: "#F54F59"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8889 21.7143L21 20.8571V20.4286L18.7778 20L18.2222 20.4286L17.6667 20.8571L17.1111 21.7143L16 22.5714L16.5556 23H18.2222L19.8889 21.7143Z",
    fill: "#F54F59"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5954 10.3885L23.5955 10.3885L23.5911 10.3935L21.8049 12.4195L26.0504 15.6918L27.7309 13.6809C27.8916 13.4887 27.957 13.2102 27.9421 13.049C27.9273 12.8877 27.8129 12.6325 27.6242 12.4829L24.8055 10.2486C24.4291 9.95019 23.9181 10.0024 23.5954 10.3885Z",
    fill: "#F54F59",
    stroke: "white",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.498 12.9727C25.5446 12.9171 25.5679 12.8429 25.5679 12.7965C25.5679 12.7501 25.5445 12.6851 25.4978 12.648L24.9608 12.2205C24.8674 12.1462 24.7273 12.1738 24.634 12.2851L24.1907 12.7901L25.078 13.4731L25.498 12.9727Z",
    fill: "#FEECED"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5673 16.8638L22.7971 17.046L22.6091 17.2709L13.296 28.4148L13.2163 28.5102L13.0897 28.5244L12.0777 28.6383L11.7662 28.6734L11.7388 28.376L11.6478 27.3877L11.6371 27.2706L11.7143 27.1782L21.0274 16.0343L21.224 15.799L21.4643 15.9895L22.5673 16.8638ZM10.2763 30.4709L14.1104 30.0393L25.0919 16.78L21.0254 13.5566L9.9305 26.7137L10.2763 30.4709Z",
    fill: "#F54F59",
    stroke: "white",
    strokeWidth: 0.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizColored);
export default __webpack_public_path__ + "static/media/quiz-colored.915662201ba9c2ca24e93c630c19504d.svg";
export { ForwardRef as ReactComponent };